import { useState, useCallback } from 'react';
import usersService from '../services/usersService';

export const useUserForm = (initialData = {}) => {
  const [formData, setFormData] = useState({
    firstName: '',
    lastName: '',
    email: '',
    phone: '',
    role: 'guest',
    status: 'active',
    bio: '',
    avatar: '',
    adminRoleId: '',
    ...initialData
  });

  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const handleChange = useCallback((e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  }, []);

  const handleSelectChange = useCallback((name, value) => {
    setFormData(prev => ({ ...prev, [name]: value }));
  }, []);

  const handleSubmit = async (isEdit = false, id = null) => {
    setLoading(true);
    setError(null);
    try {
      // Server User model is flat — no nested profile/contact objects
      const payload = {
        firstName: formData.firstName,
        lastName: formData.lastName,
        email: formData.email,
        phone: formData.phone,
        role: formData.role,
        status: formData.status,
        adminRoleId: formData.role === 'admin' && formData.adminRoleId ? parseInt(formData.adminRoleId, 10) : null
      };

      // Only include password on create; never on edit via this form
      if (!isEdit && formData.password) {
        payload.password = formData.password;
      }

      let result;
      if (isEdit && id) {
        result = await usersService.updateUser(id, payload);
      } else {
        // Create requires a password — generate a temporary one if not supplied
        if (!payload.password) {
          payload.password = `Temp@${Math.random().toString(36).slice(-8)}1`;
        }
        result = await usersService.createUser(payload);
      }
      return result;
    } catch (err) {
      setError(err.response?.data?.message || err.message || 'Failed to save user');
      return null;
    } finally {
      setLoading(false);
    }
  };

  return {
    formData,
    setFormData,
    loading,
    error,
    handleChange,
    handleSelectChange,
    handleSubmit
  };
};
